export default "__VITE_ASSET__BY4KQm1n__"